import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

import ReadingTest from '../componets/ReadingTest';
import ListeningTest from '../componets/ListeningTest';
import WritingTest from '../Questions/Celpip/Writing/WritingTest';
import SpeakingTest from '../Questions/Celpip/SpeakingTest';
import { isTestUnlocked } from '../utils/subscriptionHelper';

const Section = ({ title, children }) => (
    <section
        style={{
            marginBottom: '2rem',
            padding: '1rem',
            borderRadius: 10,
            boxShadow: '0 4px 15px rgba(123, 27, 27, 0.2)',
            backgroundColor: '#fff',
        }}
    >
        <h2
            style={{
                textTransform: 'capitalize',
                color: '#5A0000',
                borderBottom: '2px solid #7B1B1B',
                paddingBottom: '0.3rem',
                marginBottom: '1rem',
            }}
        >
            {title}
        </h2>
        {children}
    </section>
);

const FullMockTest = () => {
    const { testNumber } = useParams();
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [showResults] = useState(false);

    useEffect(() => {
        const num = Number(testNumber) || 1;
        if (num > 2 && !isTestUnlocked(num)) {
            alert("Your access has expired or this test is locked. Please renew or upgrade your account to access it.");
            navigate("/pricing?category=tests");
        }
    }, [testNumber, navigate]);

    const [results, setResults] = useState({
        listening: null,
        reading: null,
        writing: null,
        speaking: null,
    });

    const handleModuleComplete = (module, score, errors = []) => {
        setResults((prev) => ({
            ...prev,
            [module]: { score, errors },
        }));
    };

    const getCLBLevel = (score) => {
        if (score >= 10) return 'CLB 10+';
        if (score >= 9) return 'CLB 9';
        if (score >= 8) return 'CLB 8';
        if (score >= 7) return 'CLB 7';
        if (score >= 6) return 'CLB 6';
        if (score >= 5) return 'CLB 5';
        if (score >= 4) return 'CLB 4';
        return 'Below CLB 4';
    };

    const handleNext = () => {
        if (step < 4) {
            setStep(step + 1);
        }
    };

    return (
        <>
            {!showResults && step === 1 && (
                <ListeningTest
                    testNumber={testNumber}
                    isFullTest={true}
                    onComplete={(score, errors) => {
                        handleModuleComplete('listening', score, errors);
                        setStep(2);
                    }}
                />
            )}

            {!showResults && step === 2 && (
                <>
                    <ReadingTest
                        testNumber={testNumber}
                        onComplete={(score, errors) =>
                            handleModuleComplete('reading', score, errors)
                        }
                    />
                    <button onClick={handleNext} style={btnStyle}>
                        Move to Writing Test
                    </button>
                </>
            )}

            {!showResults && step === 3 && (
                <>
                    <WritingTest
                        testNumber={testNumber}
                        onComplete={(score, errors) =>
                            handleModuleComplete('writing', score, errors)
                        }
                    />
                    <button onClick={handleNext} style={btnStyle}>
                        Move to Speaking Test
                    </button>
                </>
            )}

            {!showResults && step === 4 && (
                <>
                    <SpeakingTest
                        testNumber={testNumber}
                        onComplete={(score, errors) =>
                            handleModuleComplete('speaking', score, errors)
                        }
                    />

                    <Link to="/dashboard" style={{ ...btnStyle, backgroundColor: '#004d40', textDecoration: 'none', textAlign: 'center' }}>
                        Check Progress
                    </Link>

                </>
            )}

            {showResults && (
                <div style={{ maxWidth: 900, margin: '2rem auto', padding: '0 1rem' }}>
                    <Section title="🎯 Full Test Results Summary">
                        {['listening', 'reading', 'writing', 'speaking'].map((module) => {
                            const res = results[module];
                            return res ? (
                                <div key={module} style={{ marginBottom: '1.5rem' }}>
                                    <h3 style={{ textTransform: 'capitalize', color: '#7B1B1B' }}>
                                        {module}:
                                    </h3>
                                    <p>✅ Score: <strong>{res.score}</strong></p>
                                    <p>📊 CLB Level: <strong>{getCLBLevel(res.score)}</strong></p>
                                    {res.errors && res.errors.length > 0 && (
                                        <>
                                            <p>❌ Errors:</p>
                                            <ul style={{ paddingLeft: '1.5rem' }}>
                                                {res.errors.map((err, idx) => (
                                                    <li key={idx}>{err}</li>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <p key={module}>No result found for {module}</p>
                            );
                        })}
                    </Section>
                </div>
            )}
        </>
    );
};

const btnStyle = {
    marginTop: '1rem',
    backgroundColor: '#7B1B1B',
    color: '#fff',
    padding: '0.6rem 1.5rem',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: '1rem',
};

export default FullMockTest;
